import { appCode } from '../../config';
import { ROUTES, CB_ROUTES } from '../const/routes';

// use this approach to split the code of a component, and bundle it as a separate chunk that is loaded lazily
const LandingPage = r => require.ensure([], () => r(require('@/components/LandingPage')), 'LandingPage');
const BotPlatform = r => require.ensure([], () => r(require('@/components/iframes/BotPlatform')), 'BotPlatform');
const ConvBuilder = r => require.ensure([], () => r(require('@/components/iframes/ConvBuilder')), 'BotBuilder');
const LiveIntent = r => require.ensure([], () => r(require('@/components/iframes/LiveIntent')), 'LiveIntent');

export default [
  {
    path: `/${appCode}/${ROUTES.LANDING}`,
    name: ROUTES.LANDING,
    components: { [appCode]: LandingPage },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
    },
  },
  {
    path: `/${appCode}/${ROUTES.BOT_PLATFORM}`,
    name: ROUTES.BOT_PLATFORM,
    components: { [appCode]: BotPlatform },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.botplatform',
    },
  },
  {
    path: `/${appCode}/${ROUTES.LIVE_INTENT}`,
    name: ROUTES.LIVE_INTENT,
    components: { [appCode]: LiveIntent },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.liveintent',
    },
  },
  // CB routes
  {
    path: `/${appCode}/${CB_ROUTES.BOT_BUILDER}`,
    name: CB_ROUTES.BOT_BUILDER,
    components: { [appCode]: ConvBuilder },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.botbuilder',
    },
  },
  {
    path: `/${appCode}/${CB_ROUTES.KNOWLEDGE_BASE}`,
    name: CB_ROUTES.KNOWLEDGE_BASE,
    components: { [appCode]: ConvBuilder },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.knowledgebase',
    },
  },
  {
    path: `/${appCode}/${CB_ROUTES.DOMAINS}`,
    name: CB_ROUTES.DOMAINS,
    components: { [appCode]: ConvBuilder },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.domains',
    },
  },
  {
    path: `/${appCode}/${CB_ROUTES.ANALYTICS}`,
    name: CB_ROUTES.ANALYTICS,
    components: { [appCode]: ConvBuilder },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.analytics',
    },
  },
  {
    path: `/${appCode}/${CB_ROUTES.SYS_ADMIN}`,
    name: CB_ROUTES.SYS_ADMIN,
    components: { [appCode]: ConvBuilder },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.sysadmin',
    },
  },
  {
    path: `/${appCode}/${CB_ROUTES.ORG_MGMT}`,
    name: CB_ROUTES.ORG_MGMT,
    components: { [appCode]: ConvBuilder },
    meta: {
      translationKey: 'LEUIComponents.reporting.context.automation',
      translationSubKey: 'LEUIComponents.reporting.context.automation.orgmgmt',
    },
  },
  {
    path: `/${appCode}*`,
    name: 'default',
    redirect: { path: `/${appCode}/${ROUTES.LANDING}` },
  },
];
